import React, {useState, useEffect} from 'react';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_bus";

export default function KpiSection(props) {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [gloablfilter , setGloablfilter] = useState(props.gloablfilter);
    const [refreshDate, setRefreshDate] = useState("")

    const [totalVehicleCount, setTotalVehicleCount] = useState(0);
    const [totalDrivenCount, setTotalDrivenCount] = useState(0);
    const [totalDischargeCount, setTotalDischargeCount] = useState(0);
    const [totalDistanceTravelled, setTotalDistanceTravelled] = useState(0);

    let apiprops = {};
    apiprops.startDate =  gloablfilter.startDate
    apiprops.endDate =  gloablfilter.endDate
    apiprops.city = gloablfilter.CITY
    apiprops.depo = gloablfilter.DEPO

    useEffect(() => {
      fetchData({ url: API_URL_MAIN + "trend_analysis_drive_bus/trendanalysis_refreshdate_bus", body: {} }, refreshDateData)
    }, [])

    const refreshDateData = (data) => {
      setRefreshDate(data.value_as_string);
    }

    useEffect(() => {
        fetchData(
          {
            url: API_URL_MAIN + "trend_analysis_drive_bus/totalvehiclecount",
            body: { filterdata: {
              "CITY" : apiprops.city,
              "DEPO": apiprops.depo,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "pageSelected": 1,
              "AIR_VENTILATION": "",
          }},
          },
          resposnceTotalCount
        );
    }, []);
  
    const resposnceTotalCount = (data) =>{
      setTotalVehicleCount(data[0].total_vehicle_count.value)
    }

    useEffect(() => {
        fetchData(
          {
            url: API_URL_MAIN + "trend_analysis_drive_bus/totaldrivencount",
            body: { filterdata: {
              "CITY" : apiprops.city,
              "DEPO": apiprops.depo,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "pageSelected": 1,
              "AIR_VENTILATION": "",
          }},
          },
          resposnceDrivenCount
        );
      }, []);
  
    const resposnceDrivenCount = (data) =>{
        setTotalDrivenCount(data[0].Driven_vehicle_count.value)
    }

    useEffect(() => {
        fetchData(
          {
            url: API_URL_MAIN + "trend_analysis_drive_bus/kpiTrend",
            body: { filterdata: {
              "CITY" : apiprops.city,
              "DEPO": apiprops.depo,
              "LOB": [],
              "PL": [],
              "PPL": [],
              "SOC": 0,
              "VIN_NUM": [],
              "pageSelected": 1,
              "AIR_VENTILATION": "",
          }},
          },
          resposnceDischargeCount
        );
    }, []);

    const resposnceDischargeCount = (data) =>{
        setTotalDischargeCount(data[0].vehicleId.doc_count.toLocaleString('en-IN'))
        setTotalDistanceTravelled(data[0].distanceInKM.value.toLocaleString('en-IN'))
    }

  return (
    <div className='container-fluid'>
        <div className='row mb-1'style={{textAlign:"left", color:"#02559b", fontSize:"20px"}}><b>Trend Analysis<span style={{fontSize:"10px"}}> (Last Refresh Date: {refreshDate})</span></b></div>
        <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10' style={{border:"1px solid #fff", borderRadius:"5px", backgroundColor:"#fff", boxShadow:"0px 3px 6px #00000027",}}>
                <div className='row'>
                    <div className="col-md-3" style={{ display: "flex"}}>
                        <div className="p-0 py-2 d-flex align-items-center">
                            <div className="ps-3">
                              <p className="m-0" ><small className="text-mutedf">Total Vehicle Count</small></p>
                              <p className="h5 pt-1 highBold">{totalVehicleCount}</p>
                            </div>
                            <div className="ps-3">
                              <img src='../../../assets/img_Bus/TrendAnalysis/img1.png' alt='' style={{height:"75px"}}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3" style={{borderLeft: "1px solid #afb5bd",  marginTop:"12px", marginBottom:"9px",}} >
                        <div className="p-0 py-2 d-flex align-items-center">
                            <div className="ps-3">
                              <p className="m-0 "><small className="text-mutedf" style={{fontSize:"5px" }}>Driven Vehicle Count</small></p>
                              <p className="h5 pt-1 highBold">{totalDrivenCount}</p>
                            </div>
                            <div className="ps-3">
                              <img src='../../../assets/img_Bus/TrendAnalysis/img3.png' alt='' style={{height:"75px"}}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3" style={{ display: "flex", borderLeft: "1px solid #afb5bd",  marginTop:"12px", marginBottom:"9px",}}>
                        <div className="p-0 py-2 d-flex align-items-center">
                            <div className="ps-3">
                              <p className="m-0" ><small className="text-mutedf">Total Discharge Cycle</small></p>
                              <p className="h5 pt-1 highBold">{totalDischargeCount}</p>
                            </div>
                            <div className="ps-3">
                              <img src='../../../assets/img_Bus/electric-bus (2).png' alt='' style={{height:"50px"}}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3" style={{borderLeft: "1px solid #afb5bd",  marginTop:"12px", marginBottom:"9px",}} >
                        <div className="p-0 py-2 mt-2 d-flex align-items-center">
                            <div className="ps-3">
                              <p className="m-0 "><small className="text-mutedf" style={{fontSize:"5px" }}>Distance travelled</small></p>
                              <p className="h5 pt-1 highBold">{totalDistanceTravelled}</p>
                            </div>
                            <div className="ps-3">
                              <img src='../../../assets/img_Bus/DA2_KPI_img6.png' alt='' style={{height:"60px"}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-1'></div>
        </div>
    </div>
  )
}
